import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconDrillingPartLeftFilledSizeM from './IconDrillingPartLeftFilled_size_m';
import IconDrillingPartLeftFilledSizeS from './IconDrillingPartLeftFilled_size_s';
import IconDrillingPartLeftFilledSizeXs from './IconDrillingPartLeftFilled_size_xs';

const props: CreateIconArguments = {
  l: IconDrillingPartLeftFilledSizeM,
  m: IconDrillingPartLeftFilledSizeM,
  s: IconDrillingPartLeftFilledSizeS,
  xs: IconDrillingPartLeftFilledSizeXs,
  name: 'IconDrillingPartLeftFilled',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
